export default {"src":"/_next/static/media/Logo-Granuband_pay-off-1280x405-RGB.7f0b75b9.svg","height":405,"width":1280,"blurWidth":0,"blurHeight":0};